import React from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isLoggedIn } from "./../../util";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import {
  Icon,
  Label,
  Modal,
  Grid,
  Form,
  Loader,
  Button,
  Dropdown,
  GridColumn
} from "semantic-ui-react";
import {
  fetchUseraction,
  adduser,
  EditUser,
  DeleteUser,
  fetchTemplates,
  updateCustomerEmailIds,
  FetchCustomerEmailIds,
  bulkUpdateUsersDates
} from "../../actions/users_action";
import moment from "moment";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Editmode: false,
      deleteMode: false,
      changePassMode: false,
      siteName: "",
      finalName: "",
      location: "",
      userId: "",
      user_id: "",
      editedData: false,
      loading: false,
      region: "",
      email: "",
      usersList: [],
      fileTemplates: [],
      templateNames: "",
      enableStart: "",
      enableEnd: "",
      templates: [],
      selectedTemplate: "",
      templateId: "",
      emailModalOpen: false,
      newDisbursementType: '',
      disbursements: [],
      bulkEnableStart: "",
      bulkEnableEnd: "",
      allDisbursementOptions: [
        { key: 'Hotspot', text: 'Hotspot', value: 'Hotspot' },
        { key: 'Smartspot', text: 'Smartspot', value: 'Smartspot' },
        { key: 'Wholesale', text: 'Wholesale', value: 'Wholesale' },
        { key: 'Wholesale QPS', text: 'Wholesale QPS', value: 'Wholesale QPS' },
        { key: 'Visibility Cluster', text: 'Visibility Cluster', value: 'Visibility Cluster' },
        { key: 'ISMP Cluster Incentive', text: 'ISMP Cluster Incentive', value: 'ISMP Cluster Incentive' },
        { key: 'SBD Cluster Incentive', text: 'SBD Cluster Incentive', value: 'SBD Cluster Incentive' },
        { key: 'WS Cluster Incentive', text: 'WS Cluster Incentive', value: 'WS Cluster Incentive' },
        { key: 'Small Channel LAT Incentive', text: 'Small Channel LAT Incentive', value: 'Small Channel LAT Incentive' },
        { key: 'SubD PI', text: 'SubD PI', value: 'SubD PI' },
      ],
    };
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.props.fetchTemplates({
      onSuccess: (res) => {
        this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'] })
        this.props.fetchUseraction(
          res.templates[res.templates.length - 1]['_id'],
          {
            onSuccess: (res) => {

              this.setState({ loading: false, fileTemplates: res.fileTemplates })
            },
            onFailure: () => { this.setState({ loading: false }) }
          });
        this.props.FetchCustomerEmailIds({

          onSuccess: (res) => {
            console.log(res.result,'result')
            this.setState({ disbursements: res.result })
          },
          onFailure: () => {

          }
        })

      },
      onFailure: () => {

      }
    })
  }
  componentDidUpdate(prevProps) {
    var data = this.props.user.allusers
    var prevData = prevProps.user.allusers
    if (prevData != data) {
      this.setState({ usersList: data })
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (!isLoggedIn(nextProps.auth)) {
      this.props.history.push(`/login`);
      return false;
    }
    return true;
  }

  siteNameChange = (e) => {
    this.setState({
      siteName: e.target.value,
    });
  };
  finalNameChange = (e) => {
    this.setState({
      finalName: e.target.value,
    });
  };

  locationChange = (e) => {
    this.setState({
      location: e.target.value,
    });
  };
  regionChange = (e) => {
    this.setState({
      region: e.target.value,
    });
  };

  emailChange = (e) => {
    this.setState({ email: e.target.value })
  }

  addNewUser = () => {
    this.setState({
      Editmode: true,
      editedData: false,
      siteName: "",
      finalName: "",
      region: "",
      location: "",
      email: "",
      templateNames: "",
      enableStart: "",
      enableEnd: ""
    });
  };

  addEmailIds = () => {
    this.setState({ emailModalOpen: true })
  }

  closeModal = () => {
    this.setState({
      Editmode: false,
      emailModalOpen: false
    });
  };
  closeDeleteModal = () => {
    this.setState({
      deleteMode: false,
    });
  }
  closeChangeModal = () => {
    this.setState({
      changePassMode: false,
    });
  }
  editUserDetail = (data) => {
    this.setState({
      user_id: data._id,
      userId: data.id,
      Editmode: true,
      editedData: true,
      siteName: data.siteName,
      finalName: data.finalName,
      role: data.role,
      region: data.region,
      location: data.location,
      email: data.email,
      templateNames: data.templateAccess,
      enableStart: data.enableStart,
      enableEnd: data.enableEnd
    });
  };


  deleteUser = (data) => {
    this.setState({ deleteMode: true, deleteData: data })
  };
  deleteUserAction = () => {
    var deleteId = this.state.deleteData._id
    this.props.DeleteUser(deleteId, {
      onSuccess: () => {
        this.setState({ loading: true, deleteMode: false })
        let templateId = this.state.templateId
        this.props.fetchUseraction(
          templateId,
          {
            onSuccess: (res) => {
              this.setState({ loading: false, fileTemplates: res.fileTemplates })
            },
            onFailure: () => { this.setState({ loading: false }) }
          });
      },
      onFailure: () => { },
    });
  }



  edituser = () => {
    this.setState({ loading: true })
    let siteName = this.state.siteName;
    let finalName = this.state.finalName;
    let location = this.state.location;
    let role = this.state.role;
    let region = this.state.region;
    let email = this.state.email;
    let templateAccess = this.state.templateNames;
    let enableStart = this.state.enableStart;
    let enableEnd = this.state.enableEnd;
    console.log()
    let _id = this.state.user_id;
    let id = this.state.userId
    let templateId = this.state.templateId;
    let editData = { _id, id, siteName, finalName, location, region, email, role, templateAccess, enableStart, enableEnd, templateId }
    this.props.EditUser(
      editData,
      {
        onSuccess: (res) => {
          this.setState({ loading: false })
          alert("Distributor Data Updated Succesfully")
          this.setState({ loading: true, Editmode: false })
          let templateId = this.state.templateId
          this.props.fetchUseraction(
            templateId,
            {
              onSuccess: (res) => {
                this.setState({ loading: false, fileTemplates: res.fileTemplates })
              },
              onFailure: () => { this.setState({ loading: false }) }
            });

        },
        onFailure: () => {
          this.setState({ loading: false })
          alert("User Not Updated")
        },
      }
    );
  };

  saveNewUser = async () => {
    let siteName = this.state.siteName;
    let finalName = this.state.finalName;
    let location = this.state.location;
    let region = this.state.region;
    let email = this.state.email;
    let templateAccess = this.state.templateNames;
    let enableStart = this.state.enableStart;
    let enableEnd = this.state.enableEnd;
    let templateId = this.state.templateId;

    var newUserData = {
      siteName,
      finalName,
      location,
      region,
      email,
      templateAccess,
      enableStart,
      enableEnd,
      templateId
    }
    this.setState({ loading: true })
    this.props.adduser(
      newUserData,
      {
        onSuccess: (res) => {
          alert("Distributor Added Succesfully")
          this.setState({ loading: false })
          this.setState({ Editmode: false, loading: true });
          let templateId = this.state.templateId
          this.props.fetchUseraction(
            templateId,
            {
              onSuccess: (res) => {
                this.setState({ loading: false, fileTemplates: res.fileTemplates })
              },
              onFailure: () => { this.setState({ loading: false }) }
            });
        },
        onFailure: () => {
          this.setState({ loading: false })
          alert("Something went wrong")
        },
      }
    );
  };

  onTemplateChange = (e, data) => {
    this.setState({ templateNames: data.value })
  }

  handleStartDateChange = (e, data) => {
    const formattedDate = data && data.value ? moment(data.value).format('YYYY-MM-DD') : "";
    this.setState({ enableStart: formattedDate })
  }

  handleEndDateChange = (e, data) => {
    const formattedDate = data && data.value ? moment(data.value).format('YYYY-MM-DD') : "";
    this.setState({ enableEnd: formattedDate })
  }

  handleBulkStartDateChange = (e, data) => {
    const formattedDate = data.value ? moment(data.value).format('YYYY-MM-DD') : "";
    this.setState({ bulkEnableStart: formattedDate });
  }

  handleBulkEndDateChange = (e, data) => {
    const formattedDate = data.value ? moment(data.value).format('YYYY-MM-DD') : "";
    this.setState({ bulkEnableEnd: formattedDate });
  }

  handleUpdateAllDates = () => {
    const { templateId, bulkEnableStart, bulkEnableEnd } = this.state;
    if (!templateId) {
      alert("Please select a template/month first.");
      return;
    }
    if (!bulkEnableStart || !bulkEnableEnd) {
      alert("Both 'File Upload Enable From' and 'File Upload Enable To' dates are required.");
      return;
    }

    this.setState({ loading: true });
    this.props.bulkUpdateUsersDates(
      {
        templateId: templateId,
        enableStart: bulkEnableStart,
        enableEnd: bulkEnableEnd,
      },
      {
        onSuccess: (res) => {
          alert("All distributors' upload dates updated successfully!");
          this.props.fetchUseraction(templateId, {
            onSuccess: (res) => {
              this.setState({ loading: false, fileTemplates: res.fileTemplates });
            },
            onFailure: () => { this.setState({ loading: false }); }
          });
        },
        onFailure: (err) => {
          this.setState({ loading: false });
          alert("Failed to update dates in bulk.");
        }
      }
    );
  }

  dropDownTemplateOnChange = async (e, data) => {
    let templateId = ''
    data.options.map((d) => {
      if (data.value == d.value) {
        templateId = d.key
      }
    })

    this.props.fetchUseraction(
      templateId,
      {
        onSuccess: (res) => {
          this.setState({ loading: false, fileTemplates: res.fileTemplates })
        },
        onFailure: () => { this.setState({ loading: false }) }
      });
    this.setState({ selectedTemplate: data.value, templateId: templateId })
  }

  addDisbursementType = () => {
    const { newDisbursementType, disbursements } = this.state;

    // Avoid duplicates
    if (disbursements.some(d => d.type.toLowerCase() === newDisbursementType.toLowerCase())) {
      alert('Disbursement type already exists');
      return;
    }

    this.setState({
      disbursements: [
        ...disbursements,
        { type: newDisbursementType, emails: ['', '', '', ''] }
      ],
      newDisbursementType: '',
    });
  };

  handleEmailChange = (disIndex, levelIndex, value) => {
    const disbursements = [...this.state.disbursements];
    disbursements[disIndex].emails[levelIndex] = value;
    this.setState({ disbursements });
  };

  handleSave = () => {
    let data = {
      mappings: this.state.disbursements
    }
    this.props.updateCustomerEmailIds(data, {
      onSuccess: (res) => {
        this.setState({ disbursements: res.result })
        this.setState({ emailModalOpen: false })
        alert('Details Added Successfully')
      },
      onFailure: () => {

      }
    })
    // Submit to backend if needed
    // this.closeModal();
  };

  // Add this method to your component class
removeDisbursementType = (disbursementTypeOrIndex) => {
  const updatedDisbursements = this.state.disbursements.filter((disbursement, index) => {
    // Handle both type-based and index-based removal
    if (typeof disbursementTypeOrIndex === 'string') {
      return disbursement.type !== disbursementTypeOrIndex;
    } else {
      return index !== disbursementTypeOrIndex;
    }
  });

  this.setState({
    disbursements: updatedDisbursements
  });
};



  render() {

    var data = this.state.usersList;

    var templateMonths = []

    this.state.templates.map((d) => {
      templateMonths.push({
        'key': d._id,
        'value': d.name,
        'text': d.name
      })
    })

    var templateList = []

    this.state.fileTemplates.map((d) => {
      templateList.push({
        'key': d.fileName,
        'value': d.fileName,
        'text': d.fileName
      })
    })
    var columns = [
      {
        Header: "Site Name",
        accessor: "siteName",
      },
      {
        Header: "User Name",
        accessor: "userName",
      },
      {
        Header: "Location",
        accessor: "location",
      },
      {
        Header: "Role",
        accessor: "role",
      },
      {
        Header: "Edit",
        accessor: "editing",
        Cell: (row) => (
          <div>
            {!this.state.Editmode && (
              <Icon
                name="edit"
                onClick={() => this.editUserDetail(row.original)}
                style={{
                  width: 100,
                  align: "center",
                  size: "huge",
                  marginLeft: "25%",
                  cursor: "pointer",
                  color: "green",
                }}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Delete",
        accessor: "delete",
        Cell: (row) => (
          <div>
            <Icon
              name="delete"
              onClick={() => this.deleteUser(row.original)}
              disabled={this.props.auth.userName == 'MatrixLogin' ? true : false}
              style={{
                width: 100,
                align: "center",
                size: "huge",
                marginLeft: "25%",
                cursor: "pointer",
                color: "red",
              }}
            ></Icon>
          </div>
        ),
      }
    ];
    return (
      <div style={{ height: "100%", backgroundColor: "white" }}>
        <Modal open={this.state.loading}>
          <Loader>Loading</Loader>
        </Modal>
        <div style={{ width: "200%" }}>
          <h1
            style={{
              paddingLeft: 30,
              flex: "0 0 30px",
              display: "inline-block",
              color: "#2185d0",
            }}
          >
            Distributor Details
          </h1>
          <br />
          <div style={{ paddingLeft: 30, paddingRight: 30 }}>
            {/* Top Action Bar */}
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: '15px' }}>
              <div>
                <Dropdown placeholder='Select Month' search selection options={templateMonths}
                  onChange={this.dropDownTemplateOnChange}
                  value={this.state.selectedTemplate}
                />
              </div>
              <div>
                <Label
                  style={{ cursor: "pointer", margin: 0 }}
                  size="large"
                  color="blue"
                  onClick={this.addNewUser}
                >
                  <Icon name="user plus" />
                  Add Distributor
                </Label>
              </div>
              <div>
                <Label
                  style={{ cursor: "pointer", margin: 0 }}
                  size="large"
                  color="blue"
                  onClick={this.addEmailIds}
                >
                  <Icon name="envelope" />
                  P&G Mail Mappings
                </Label>
              </div>
            </div>

            {/* Bulk Upload Dates Section */}
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '15px',
              background: '#f8f9fa',
              border: '1px solid #e9ecef',
              padding: '15px',
              borderRadius: '8px',
              marginTop: '15px',
              marginBottom: '15px',
              maxWidth: '950px'
            }}>
              <div style={{ fontWeight: 'bold', color: '#495057', minWidth: '150px' }}>
                Overall Template Enable Dates:
              </div>
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <SemanticDatepicker
                  placeholder="File Upload Enable From"
                  pointing={'top left'}
                  onChange={this.handleBulkStartDateChange}
                  value={this.state.bulkEnableStart ? new Date(this.state.bulkEnableStart) : null}
                />
              </div>
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <SemanticDatepicker
                  placeholder="File Upload Enable To"
                  pointing={'top left'}
                  onChange={this.handleBulkEndDateChange}
                  value={this.state.bulkEnableEnd ? new Date(this.state.bulkEnableEnd) : null}
                />
              </div>
              <div>
                <Button
                  color="green"
                  size="medium"
                  disabled={!this.state.bulkEnableStart || !this.state.bulkEnableEnd}
                  onClick={this.handleUpdateAllDates}
                  style={{ margin: 0 }}
                >
                  Update All Dates
                </Button>
              </div>
            </div>
          </div>



          <div style={{ display: "flex", overflowX: "scroll", marginTop: 20 }}>
            <ReactTable
              noDataText="We couldn't find anything"
              filterable={true}
              defaultPageSize={20}
              sortable={true}
              style={{ width: "85vw", marginLeft: 30 }}
              columns={columns}
              data={data}
            />
          </div>

          <Modal
            open={this.state.Editmode}
            onClose={this.closeModal}
            size="small"
          >
            <Modal.Content>
              <Form>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="text"
                        label="Site Name"
                        value={this.state.siteName}
                        onChange={(e) => this.siteNameChange(e)}
                        placeholder="Site Name"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="text"
                        label="Final Name"
                        value={this.state.finalName}
                        onChange={(e) => this.finalNameChange(e)}
                        placeholder="Final Name"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="any"
                        label="Location"
                        value={this.state.location}
                        onChange={(e) => this.locationChange(e)}
                        placeholder="location"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="any"
                        label="Region"
                        value={this.state.region}
                        onChange={(e) => this.regionChange(e)}
                        placeholder="region"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="any"
                        label="Email"
                        value={this.state.email}
                        onChange={(e) => this.emailChange(e)}
                        placeholder="email"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <h5>File Templates</h5>
                      <Dropdown placeholder='File Templates' fluid multiple selection options={templateList}
                        onChange={this.onTemplateChange}
                        value={this.state.templateNames}
                      />
                    </Grid.Column>
                    <GridColumn style={{ marginTop: 20 }}>
                      <h5>File Upload Enable From</h5>
                      <SemanticDatepicker
                        filterDate={(date) => {
                          const selectedMonth = new Date().getMonth();
                          const selectedYear = new Date().getFullYear();
                          const now = new Date();
                          now.setDate(now.getDate() - 1);

                          return date.getMonth() === selectedMonth && date.getFullYear() === selectedYear;
                        }}
                        pointing={'top left'}
                        onChange={this.handleStartDateChange}
                        value={this.state.enableStart != '' && this.state.enableStart != undefined ? new Date(this.state.enableStart) : this.state.enableStart}
                      />
                    </GridColumn>
                    <GridColumn style={{ marginTop: 20 }}>
                      <h5>File Upload Enable To</h5>
                      <SemanticDatepicker
                        filterDate={(date) => {
                          const now = new Date();
                          now.setDate(now.getDate() - 1);
                          const selectedMonth = date.getMonth();
                          const selectedYear = date.getFullYear();
                          return (
                            (selectedYear > now.getFullYear()) ||
                            (selectedYear === now.getFullYear() && selectedMonth >= now.getMonth())
                          );
                        }}
                        pointing={'top left'}
                        onChange={this.handleEndDateChange}
                        value={this.state.enableEnd != '' && this.state.enableEnd != undefined ? new Date(this.state.enableEnd) : this.state.enableEnd}
                      />
                    </GridColumn>
                    <GridColumn>
                    </GridColumn>
                    <GridColumn></GridColumn>
                  </Grid.Row>
                </Grid>
              </Form>
            </Modal.Content>
            <Modal.Actions style={{ marginTop: 20 }}>
              <Button color="red" onClick={this.closeModal}>
                <Icon name="remove" /> Cancel
              </Button>
              {this.state.Editmode &&
                <Button
                  color="green"
                  onClick={
                    this.state.editedData ? this.edituser : this.saveNewUser
                  }
                >
                  Save
                </Button>
              }
            </Modal.Actions>
          </Modal>
          <Modal
            open={this.state.emailModalOpen}
            onClose={this.closeModal}
            size="large"
          >
            <Modal.Content>
              <Form>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 12,
                  marginBottom: 15
                }}>
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '6px',
                    padding: '15px',
                    color: '#495057',
                    fontSize: '12px',
                    lineHeight: '1.5'
                  }}>
                    <div style={{
                      fontWeight: '400',
                      color: '#dc3545',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px'
                    }}>
                      <span style={{ color: '#dc3545' }}>⚠</span>
                      4-Level Escalation Matrix
                    </div>

                    <ul style={{
                      margin: '0',
                      paddingLeft: '20px',
                      color: '#6c757d'
                    }}>
                      <li style={{ marginBottom: '4px' }}>
                        Initial Approval triggers email to <strong style={{ color: '#495057' }}>Level 1</strong>
                      </li>
                      <li style={{ marginBottom: '4px' }}>
                        If no reply in 24 hrs → follow-up to <strong style={{ color: '#495057' }}>Level 1</strong>
                      </li>
                      <li style={{ marginBottom: '4px' }}>
                        If no reply in 48 hrs → <strong style={{ color: '#495057' }}>Level 2</strong> added in CC + follow-up
                      </li>
                      <li style={{ marginBottom: '4px' }}>
                        After another 48 hrs → <strong style={{ color: '#495057' }}>Level 3</strong> added in CC + follow-up
                      </li>
                      <li>
                        Same pattern continues for <strong style={{ color: '#495057' }}>Level 4</strong> if no response
                      </li>
                    </ul>
                  </div>
                  {/* Main Controls Row */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 15
                  }}>
                    {/* Dropdown */}
                    <Dropdown
                      placeholder="Select Disbursement Name"
                      fluid
                      selection
                      options={this.state.allDisbursementOptions.filter(
                        (opt) => !this.state.disbursements.find((d) => d.type === opt.value)
                      )}
                      value={this.state.newDisbursementType}
                      onChange={(e, { value }) => this.setState({ newDisbursementType: value })}
                      style={{ flex: 1, minWidth: 250 }}
                    />

                    {/* Button */}
                    <Button
                      color="blue"
                      onClick={this.addDisbursementType}
                      disabled={!this.state.newDisbursementType.trim()}
                      style={{
                        height: '38px',
                        minWidth: '80px',
                        flexShrink: 0
                      }}
                    >
                      Add
                    </Button>
                  </div>

                  {/* Information Panel */}

                </div>



                {/* Header Row */}
                <Grid columns={5} padded>
                  <Grid.Row>
                    <Grid.Column><strong>Disbursement Name</strong></Grid.Column>
                    <Grid.Column><strong>Level 1</strong></Grid.Column>
                    <Grid.Column><strong>Level 2</strong></Grid.Column>
                    <Grid.Column><strong>Level 3</strong></Grid.Column>
                    <Grid.Column><strong>Level 4</strong></Grid.Column>
                  </Grid.Row>

                  {/* Dynamic Disbursement Rows */}
                 {this.state.disbursements.map((dis, index) => (
  <Grid.Row key={index}>
    <Grid.Column width={3}>
      {dis.type}
    </Grid.Column>
    {[0, 1, 2, 3].map((lvl) => (
      <Grid.Column width={3} key={lvl}>
        <Form.Input
          placeholder={`Level ${lvl + 1} Email`}
          value={this.state.disbursements[index].emails[lvl]}
          onChange={(e) => this.handleEmailChange(index, lvl, e.target.value)}
        />
      </Grid.Column>
    ))}
    <Grid.Column width={1}>
      <Button
        color="red"
        size="small"
        icon="trash"
        onClick={() => this.removeDisbursementType(dis.type || index)}
        style={{ 
          minWidth: '36px',
          height: '32px',
          padding: '0 8px'
        }}
        title={`Delete ${dis.type || 'disbursement'}`}
      />
    </Grid.Column>
  </Grid.Row>
))}
                </Grid>
              </Form>
            </Modal.Content>

            <Modal.Actions style={{ marginTop: 20 }}>
              <Button color="red" onClick={this.closeModal}>
                <Icon name="remove" /> Cancel
              </Button>
              <Button color="green" onClick={this.handleSave}>
                <Icon name="check" /> Save
              </Button>
            </Modal.Actions>
          </Modal>

          <Modal
            open={this.state.deleteMode}
            onClose={this.closeDeleteModal}
            size="mini"
          >
            <Modal.Header>
              Delete User
            </Modal.Header>
            <Modal.Description>
              <div style={{ marginLeft: 30 }}>
                <p>   </p> Are you sure want to delete this Distributor
                <p>   </p> Name : {this.state.deleteData?.siteName ?? ""} <br />
              </div>
            </Modal.Description>
            <Modal.Actions style={{ marginTop: 20 }}>
              <Button color="black" onClick={this.closeDeleteModal}>
                <Icon name="remove" /> Cancel
              </Button>
              <Button
                color="red"
                onClick={this.deleteUserAction}
              >
                Delete
              </Button>
            </Modal.Actions>
          </Modal>
        </div>
      </div>
    );
  }
}

function AuditTableCell(props) {
  function onClick() {
    props.onClick(props.row);
  }
  return (
    <div style={props.style} onClick={onClick}>
      {props.text}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchUseraction: fetchUseraction,
      adduser: adduser,
      EditUser: EditUser,
      DeleteUser: DeleteUser,
      fetchTemplates,
      updateCustomerEmailIds,
      FetchCustomerEmailIds,
      bulkUpdateUsersDates
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users));